import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, strokeWidth, typography } = themeVariables;

/** No token exists for a control's minimum tap target. */
const MIN_TAP_TARGET = '44px';

/** The anchor the listbox hangs from. */
export const root = css`
  position: relative;
  flex: 0 0 auto;
`;

/**
 * A compact pill, as designed. Buttons do not inherit the document font, so the body
 * typography is restated.
 */
export const trigger = css`
  display: inline-flex;
  align-items: center;
  gap: var(${spacing.xxs});
  padding: var(${spacing.xxs}) var(${spacing.sm});
  border: var(${strokeWidth}) solid var(${colors.stroke.interactive});
  border-radius: var(${borderRadius.full.mobile});
  background-color: var(${colors.surface.default});
  font-family: var(${typography.body.fontFamily});
  font-weight: var(${typography.body.fontWeight});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.interactive});
  cursor: pointer;

  &:focus-visible {
    outline: var(${strokeWidth}) solid var(${colors.stroke.focus});
    outline-offset: 2px;
  }
`;

/**
 * Hangs below the button, right edges aligned, over whatever follows. Below rather than
 * above: the drawer's content scrolls, and a panel opening upwards from a button near its
 * top would be clipped.
 */
export const listbox = css`
  position: absolute;
  top: calc(100% + var(${spacing.xs}));
  right: 0;
  z-index: 1;
  min-width: 160px;
  margin: 0;
  padding: var(${spacing.xs}) 0;
  list-style: none;
  border-radius: var(${borderRadius.md.mobile});
  background-color: var(${colors.surface.brand});
`;

export const option = css`
  display: flex;
  align-items: center;
  min-height: ${MIN_TAP_TARGET};
  padding: var(${spacing.xs}) var(${spacing.md});
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.default});
  cursor: pointer;

  /* A colour, not a weight: the heading weight is no heavier than the body's at this size. */
  &[aria-selected='true'] {
    color: var(${colors.content.selected});
    font-weight: var(${typography.heading.fontWeight});
  }

  &[aria-disabled='true'] {
    color: var(${colors.content.disabled});
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: var(${strokeWidth}) solid var(${colors.stroke.focus});
    outline-offset: -2px;
  }
`;
